var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 51,
    viewBox: "0 0 50 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 15.5V35.5M25 15.5C23.25 15.5 19.98 20.485 18.75 21.75M25 15.5C26.75 15.5 30.02 20.485 31.25 21.75",
    stroke: "#572148",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.25 25.5C1.25 14.305 1.25 8.705 4.7275 5.2275C8.205 1.75 13.8025 1.75 25 1.75C36.195 1.75 41.795 1.75 45.2725 5.2275C48.75 8.705 48.75 14.3025 48.75 25.5C48.75 36.695 48.75 42.295 45.2725 45.7725C41.795 49.25 36.1975 49.25 25 49.25C13.805 49.25 8.205 49.25 4.7275 45.7725C1.25 42.295 1.25 36.6975 1.25 25.5Z",
    stroke: "#572148",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.8f4231b82009c29fcb15519e7c276ff5.svg";
export { ForwardRef as ReactComponent };